import React, { useRef, useLayoutEffect } from 'react'
import { Link } from 'react-router-dom'
import { DribbbleOutlined, StopOutlined, StopFilled, DribbbleCircleFilled } from '@ant-design/icons'

const Slider = props => {
    const stickyHeader = useRef();
    return(
        <div>
            <div id="ant-anchor-header-div" ref={stickyHeader}>
                <div className="ant-anchor-wrapper ant-anchor-wrapper-horizontal">
                    <div className="ant-anchor" style={{background: '#3C777C'}}>
                        <Link to="/pot one by c on">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><StopFilled /><br/>Cricket</div>
                            </div>
                        </Link>
                        <Link to="/pot one by f do">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><DribbbleCircleFilled /><br/>Football</div>
                            </div>
                        </Link>
                        <Link to="/pot one by t no">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><StopOutlined /><br/>Tennis</div>
                            </div>
                        </Link>
                        <Link to="/pot one by v yes">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><DribbbleOutlined /><br/>Table Tannis</div>
                            </div>
                        </Link>
                        <Link to="/pot one by c on">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><StopFilled /><br/>Cricket</div>
                            </div>
                        </Link>
                        <Link to="/pot one by f do">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><DribbbleCircleFilled /><br/>Football</div>
                            </div>
                        </Link>
                        <Link to="/pot one by t no">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><StopOutlined /><br/>Tennis</div>
                            </div>
                        </Link>
                        <Link to="/pot one by v yes">
                            <div className="ant-anchor-link">
                                <div className="ant-anchor-link-title"><DribbbleOutlined /><br/>Table Tannis</div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Slider